package com.parmartechnologies.commerce.feature.inventory.viewModel.coupon


import com.parmartechnologies.business.feature.business.handler.BusinessHandler
import com.parmartechnologies.core.feature.inventory.coupon.model.Coupon
import com.parmartechnologies.core.feature.inventory.coupon.network.CreateCouponRequest
import com.parmartechnologies.core.feature.inventory.coupon.network.RetrieveCouponRequest
import com.parmartechnologies.core.feature.inventory.coupon.network.UpdateCouponRequest
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.commerce.feature.inventory.handler.CouponHandler
import com.parmartechnologies.commerce.feature.inventory.network.coupon.CouponNetwork
import com.parmartechnologies.commerce.feature.inventory.repository.CouponRepository
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.storage.table.inventory.coupon.CouponDatabaseTable
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class CouponViewModel(val business: Business, val repository: CouponRepository = CouponHandler.shared().repository) :
    AppViewModel() {

    val allCoupon: StateFlow<List<Coupon>>
        get() = repository.couponLiveData

    val selectedCoupon: StateFlow<Coupon?>
        get() = repository.selectedCoupon

    fun fetchAllCoupon() {
        loadFromStorage()
        if (allCoupon.value.isEmpty()) {
            val request =
                RetrieveCouponRequest(business._id)
            // startLoading()
            scope.launch {
                CouponNetwork().retrieve(request) {
                    stopLoading()
                    CouponDatabaseTable().insert(it?.payload)
                    loadFromStorage()
                }
            }
        }
    }

    fun loadAllCoupon() {
        fetchAllCoupon()
    }

    private fun loadFromStorage() {
        CouponDatabaseTable().retrieveAll(business._id) { data ->
            scope.launch {
                repository.couponLiveData.emit(data)
            }
        }
    }

    fun createNewCoupon(name: String, amount: String, description: String, completion: () -> Unit) {
        val request = CreateCouponRequest(
            name,
            amount,
            description,
            business._id,
            AuthHandler.shared().UserID
        )
        startLoading()
        scope.launch {
            CouponNetwork().create(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    scope.launch {
                        val allCoupon: MutableList<Coupon> =
                            repository.allCoupon.value.toMutableList()
                        allCoupon.add(it.payload!!)
                        repository.couponLiveData.emit(allCoupon)
                        CouponDatabaseTable().insert(it.payload)
                        completion()
                    }
                }
            }
        }
    }

    fun updateCoupon(name: String, id: String, amount: String, description: String, completion: () -> Unit) {
        val request = UpdateCouponRequest(
            name,
            id,
            amount,
            description,
            business._id,
            AuthHandler.shared().UserID
        )
        startLoading()
        scope.launch {
            CouponNetwork().update(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    scope.launch {
                        val allCoupon: MutableList<Coupon> =
                            repository.allCoupon.value.toMutableList()
                        allCoupon.add(it.payload!!)
                        repository.couponLiveData.emit(allCoupon)
                        CouponDatabaseTable().insert(it.payload)
                        completion()
                    }
                }
            }
        }
    }
}